











import Vue from 'vue';

const HEART = () => import('../../svg/tag-icon/icon-heart.vue');
const PREFERENCES = () => import('../../svg/tag-icon/icon-preferences.vue');
const DESTINATION = () => import('../../svg/tag-icon/icon-destination-highlights.vue');

const DomainTitles = {
  ACCOMMODATION: 'Stays',
  EXPERIENCE: 'Activities',
  DINING: 'Dining',
  FLIGHTS: 'Filghts',
};

export default Vue.extend({
  name: 'Tag',
  props: {
    withCheck: {
      type: Boolean,
      default: false,
    },
    darkSelection: {
      type: Boolean,
      default: false,
    },
    tag: {
      type: Object,
      default: () => ({name: '', isActive: false, iconType: ''}),
    },
    showDomain: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tagDomain(): string {
      return DomainTitles[this.tag.domain as keyof typeof DomainTitles] || this.tag.domain;
    },
    cssClass(): {[key: string]: boolean} {
      return {
        disabled: this.tag.disabled,
        selected: this.tag.isActive,
        'tag-withcheckmark': this.withCheck,
        darkSelection: this.darkSelection,
      };
    },
    tagIcon() {
      if (this.tag.iconType === 'HEART') {
        return HEART;
      } else if (this.tag.iconType === 'PREFERENCES') {
        return PREFERENCES;
      } else if (this.tag.iconType === 'DESTINATION') {
        return DESTINATION;
      } else {
        return null;
      }
    },
  },
});
